import { makeStyles } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import React from 'react';
import useWidth from 'v2/hooks/useWidth';

const useStyles = makeStyles((theme) => ({
  tdCardRow: {
    width: '100%',
    borderRadius: 6,
    overflow: 'hidden',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    background: theme.palette.grey[100],
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  tRow: {
    width: '100%',
    borderRadius: 6,
    overflow: 'hidden',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    background: theme.palette.grey[100],
    minHeight: theme.spacing(2) * 6,
  },
}));

interface IProps {
  children: React.ReactNode;
  onDoubleClick?: any;
  onClick?: any;
  hover?: any;
  style?: any;
  className?: any;
}

const MyTableRow = ({ children, onDoubleClick, onClick }: IProps) => {
  const width = useWidth();
  const classes = useStyles({});

  if (width === 'md' || width === 'lg' || width === 'xl') {
    return (
      <tr data-testid='table-row' onDoubleClick={onDoubleClick} onClick={onClick} className={classes.tRow}>
        {children}
      </tr>
    );
  }

  return (
    <Grid data-testid='table-row' onClick={onClick} onDoubleClick={onDoubleClick} container={true} justify='flex-start' className={classes.tdCardRow}>
      {children}
    </Grid>
  );
};

export default MyTableRow;
